export default __webpack_public_path__ + "static/media/address.d8e12605.svg";